import AnalyticsParamType from "../../../../../shared/types/AnalyticsParamType";
import React from "react";
import { useMyExpAnalytics } from "../index";
import { AnalyticsEventNameEnum } from "shared/enums/AnalyticsEnums";
import AnalyticsDatastoreType from "shared/enums/AnalyticsDatastoreType";

export default function useLogAnalyticsScreenHook(props: {
  properties: AnalyticsParamType & Required<Pick<AnalyticsParamType, "screenType">>;
  isInternalEvent?: boolean;
  refreshKey?: string;
}) {
  const { logEvent } = useMyExpAnalytics();
  React.useEffect(() => {
    logEvent(
      AnalyticsEventNameEnum.SCREEN_VIEW,
      props.properties,
      props.isInternalEvent ? AnalyticsDatastoreType.MIXPANEL_INTERNAL : AnalyticsDatastoreType.MIXPANEL_BUSINESS
    );
    return () => {
      // Commenting for now to limit no of event
      // logEvent(AnalyticsEventNameEnum.SCREEN_LEAVE, props.properties);
    };
    // eslint-disable-next-line
  }, [props.refreshKey]);

  return null;
}
